import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Grade/';

const getGradeById = async (gradeId) => axiosInstance.get(`${ENDPOINTORIGIN}GetGradeById?gradeId=${gradeId}`, constants.REQUIRE_INTERCEPTORS);

const createGrade = async (grade) => axiosInstance.post(`${ENDPOINTORIGIN}CreateGrade`, grade, constants.REQUIRE_INTERCEPTORS);

const updateGrade = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateGrade`, model, constants.REQUIRE_INTERCEPTORS);

const deleteGrade = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteGrade?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getGradeById,
  createGrade,
  updateGrade,
  deleteGrade,
};